module.exports = __webpack_public_path__ + "static/DeviantART-ff77629f482ace47dd7f800bd6d2327e.jpg";